import React from 'react';
import classnames from 'classnames';
import { useDeviationViewContext } from '../../../../Context';
import Flex from '@wix/da-ds/pkg/Flex';
import ActionBarStrip from '../../../_partials/ActionBarStrip';
import FluidMargin from '../FluidMargin';
import { useDeviationAttributes } from '../../../../DeviationViews/hooks/useDeviationAttributes';
import { isTextualDeviation } from '../../../../DeviationViews/_helpers';
import CommentButton from '../../../buttons/CommentButton';
import FavouriteButton from '../../../buttons/FavouriteButtonWithPopover';
import AddToGroupButton from '../../../buttons/AddToGroupButton/AddToGroupButtonWithPopover';
import MoreButton from '../../../buttons/MoreButton';
import desktopActionBarStyles from '../DesktopActionBar.scss';
export var SecondaryDesktopActionBar = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner;
    var isTheater = useDeviationViewContext().isTheater;
    var _b = useDeviationAttributes(deviation, isOwner), isCommentable = _b.isCommentable, isFavouritable = _b.isFavouritable, isGroupSubmittable = _b.isGroupSubmittable, hasMoreActions = _b.hasMoreActions;
    var isTextual = isTextualDeviation(deviation);
    return (React.createElement(ActionBarStrip, { className: classnames(desktopActionBarStyles['root'], isTheater
            ? desktopActionBarStyles['theater']
            : desktopActionBarStyles['normal-view'], isOwner && desktopActionBarStyles['owner'], isTextual && desktopActionBarStyles['literature'], desktopActionBarStyles['secondary']) },
        React.createElement("div", { className: desktopActionBarStyles['icons-wrapper'] },
            React.createElement("div", { className: desktopActionBarStyles['badge'] }),
            React.createElement(FluidMargin, { index: 1 }),
            React.createElement("div", { className: desktopActionBarStyles['icons-middle'] },
                React.createElement(Flex, { alignItems: "center" },
                    isFavouritable && (React.createElement("span", { className: desktopActionBarStyles['icon'] },
                        React.createElement(FavouriteButton, { deviation: deviation, actionBarType: "secondary" }))),
                    isCommentable && (React.createElement("span", { className: desktopActionBarStyles['icon'] },
                        React.createElement(CommentButton, { deviation: deviation, isOwner: isOwner, actionBarType: "secondary" })))),
                React.createElement(FluidMargin, { index: 4 }),
                React.createElement(Flex, { alignItems: "center" },
                    isGroupSubmittable && (React.createElement("span", { className: desktopActionBarStyles['icon'] },
                        React.createElement(AddToGroupButton, { deviation: deviation, actionBarType: "secondary" }))),
                    hasMoreActions && (React.createElement("span", { className: desktopActionBarStyles['icon'] },
                        React.createElement(MoreButton, { deviation: deviation })))),
                React.createElement(FluidMargin, { index: 2 }),
                React.createElement(Flex, { alignItems: "center" })),
            React.createElement(FluidMargin, { index: 3 }),
            React.createElement("div", { className: desktopActionBarStyles['icons-right'] }))));
};
SecondaryDesktopActionBar.displayName = 'SecondaryDesktopActionBar';
export default SecondaryDesktopActionBar;
//# sourceMappingURL=SecondaryDesktopActionBar.js.map